import { INavNode } from "@logex/framework/lg-application";
import { ApplicationPermissions } from "./app-permissions";
import { PageNavId } from "./types";
import { concat, map, mergeWith, Observable, of, startWith, Subject } from "rxjs";
import { debounceTime, merge } from "rxjs/operators";

const navTree: INavNode[] = [
    {
        path: "dashboard",
        noBreadcrumb: true,
        id: "dashboard",
        noNumber: true,
        hidden: true
    },
    {
        path: "",
        noBreadcrumb: true,
        id: "root",

        children: [
            {
                path: "overview",
                id: "overview",
                lid: "APP._Navigation.OverviewSubMenu",
                children: [
                    {
                        id: PageNavId.keyPerformanceIndicators,
                        path: "kpi",
                        lid: "APP._Navigation.Overview.Kpi",
                        permissions: [ApplicationPermissions.KPI_ACCESS]
                    },
                    {
                        id: PageNavId.bestPractices,
                        path: "best-practices",
                        lid: "APP._Navigation.Overview.BestPractices",
                        permissions: [ApplicationPermissions.BEST_PRACTICES_ACCESS]
                    },
                    {
                        id: PageNavId.monitoring,
                        path: "monitoring",
                        lid: "APP._Navigation.Overview.Monitoring",
                        permissions: [ApplicationPermissions.MONITORING_ACCESS]
                    }
                ]
            },
            {
                path: "analysis",
                id: "analysis",
                lid: "APP._Navigation.AnalysisSubMenu",
                children: [
                    {
                        id: PageNavId.practiceVariation,
                        path: "practice-variation",
                        lid: "APP._Navigation.Analysis.PracticeVariation",
                        permissions: [ApplicationPermissions.PRACTICE_VARIATION_ACCESS]
                    },
                    {
                        id: PageNavId.processVariation,
                        path: "process-variation",
                        lid: "APP._Navigation.Analysis.ProcessVariation",
                        permissions: [ApplicationPermissions.PROCESS_VARIATION_ACCESS]
                    }
                ]
            }
        ]
    },
    {
        path: "settings",
        lid: "APP._Sidebar.Settings",
        id: "settings",
        noNumber: true,
        children: [
            {
                path: "general",
                id: "settings-1",
                lid: "APP._Navigation.Settings_general",
                children: [
                    {
                        path: "costprice",
                        lid: "APP._Navigation.Settings_costing",
                        id: "settings-1-1"
                        // permissions: [permissions.ViewSettings]
                    }
                ]
            }
        ]
    } // Settings
];
const rebuildNavigationSubject = new Subject<void>();

export const rebuildNavigation = (): void => rebuildNavigationSubject.next();

export const navigation = (): Observable<INavNode[]> =>
    rebuildNavigationSubject.pipe(
        debounceTime(10),
        map(() => filterNavNodes(navTree))
    );

function filterNavNodes(nodes: INavNode[]): INavNode[] {
    const res: INavNode[] = [];
    for (let node of nodes) {
        if (!node.children?.length) {
            node = {
                ...node,
                children: node.children
            };
        }

        res.push(node);
    }
    return res;
}
